module.exports = __webpack_public_path__ + "static/img/carbon.089ea25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bayWindow/carbon.png
// module id = 1xS2
// module chunks = 1